import { memo } from "react";

import { CurrencyDisplay } from "commonComponents/financial/CurrencyDisplay/CurrencyDisplay";
import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";

function ColumnCurrencyInternal(props: IGridCellRendererParams) {
    const { value, className } = props;

    if (value === null || value === undefined) {
        return null;
    }

    return (
        <CurrencyDisplay
            value={value}
            decimalScale={2}
            className={className}
            data-testid={`ag-grid-col-currency.${props.colDef?.field}.${props.node.rowIndex!}`}
        />
    );
}

export const columnCurrency = memo(ColumnCurrencyInternal);
